import { render, staticRenderFns } from "./AvoidedCostsNature.vue?vue&type=template&id=34fce73c&scoped=true"
import script from "./AvoidedCostsNature.vue?vue&type=script&lang=js"
export * from "./AvoidedCostsNature.vue?vue&type=script&lang=js"
import style0 from "./AvoidedCostsNature.vue?vue&type=style&index=0&id=34fce73c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34fce73c",
  null
  
)

export default component.exports